var ebookRecaptchaId = null;
var xmasEbookRecaptchaId = null;
var bfEbookRecaptchaId = null;
var contactRecaptchaId = null;

// Renderiza un recaptcha sólo si el placeholder existe en la página actual.
// Algunas páginas (la home, por ejemplo) ya no contienen los formularios legacy,
// pero el bundle JS es compartido — sin guards, grecaptcha.render lanza error.
function _safeRenderRecaptcha(elementId) {
  if (!document.getElementById(elementId)) return null;
  return grecaptcha.render(elementId, {
    'sitekey': '6Ld6mogaAAAAAKOp654-qZ2fAt-737binn4EeXOr',
    callback: function () {
      var el = document.getElementById(elementId);
      if (!el) return;
      el.classList.add('is-valid');
      el.classList.remove('border-danger');
      el.classList.remove('border');
    }
  });
}

var onloadCallback = function () {
  ebookRecaptchaId = _safeRenderRecaptcha('ebookRecaptcha');
  xmasEbookRecaptchaId = _safeRenderRecaptcha('xmasEbookRecaptcha');
  bfEbookRecaptchaId = _safeRenderRecaptcha('bfEbookRecaptcha');
  contactRecaptchaId = _safeRenderRecaptcha('contactRecaptcha');
}

// Engancha el submit handler de un formulario legacy con guard.
// Devuelve true si el form existía y se enganchó.
function _wireLegacyForm(formId, recaptchaId, recaptchaElementId, submitFn) {
  var form = document.getElementById(formId);
  if (!form) return false;
  form.addEventListener('submit', function (event) {
    var recaptcharesponse = (typeof grecaptcha !== 'undefined' && recaptchaId !== null)
      ? grecaptcha.getResponse(recaptchaId) : '';
    if (form.checkValidity() === false || !recaptcharesponse || recaptcharesponse.length === 0) {
      event.preventDefault();
      event.stopPropagation();
      var rEl = document.getElementById(recaptchaElementId);
      if (rEl && (!recaptcharesponse || recaptcharesponse.length === 0)) {
        rEl.classList.add('border', 'border-danger');
      }
    } else {
      submitFn(event, recaptcharesponse);
    }
    form.classList.add('was-validated');
  }, false);
  return true;
}

window.addEventListener('load', function () {
  _wireLegacyForm('contact-form', contactRecaptchaId, 'contactRecaptcha', function (e, r) {
    submitToAPI(e, r);
  });
  _wireLegacyForm('ebook-form', ebookRecaptchaId, 'ebookRecaptcha', function (e, r) {
    submitEbookToAPI(e, r);
  });
  _wireLegacyForm('xmas-ebook-form', xmasEbookRecaptchaId, 'xmasEbookRecaptcha', function (e, r) {
    submitEbookToAPI(e, r, 'xmas');
  });

  // var bfEbookForm = document.getElementById('bf-ebook-form');
  // // Loop over them and prevent submission
  // bfEbookForm.addEventListener('submit', function (event) {
  //   console.log(event);
  //   var recaptcharesponse = grecaptcha.getResponse(bfEbookRecaptchaId);
  //   console.log("recaptcha", recaptcharesponse);
  //   if (bfEbookForm.checkValidity() === false
  //     || recaptcharesponse.length === 0) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     if (recaptcharesponse.length === 0) {
  //       document.getElementById('bfEbookRecaptcha').classList.add('border', 'border-danger')


  //     }
  //   } else {
  //     submitToAPI(event, recaptcharesponse, 'bf');
  //   }
  //   bfEbookForm.classList.add('was-validated');

  // }, false);


}, false);

$(function () {

  "use strict";

  //===== Prealoder

  $(window).on('load', function (event) {
    $('.preloader').delay(500).fadeOut(500);

    var hash = window.location.hash;
    if (hash === '#ebook_navidad') {
      $('#exampleModalXmas').modal('show');
      setTimeout(function () {
        $('#exampleModalXmas').modal('show');
      }, 1000);
    } else if (hash === '#ebook_planner') {
      setTimeout(function () {
        $('#exampleModal').modal('show');
      }, 1000);
    } 
    // else {
    //   setTimeout(function () {
    //     ml_account('webforms', '4842188', 'a7b3p5', 'show');
    //   }, 3000);
    // }


    // setTimeout(function () {
    //   ml_account('webforms', '4842188', 'a7b3p5', 'show');
    // }, 5000);
  });


  //===== Sticky

  $(window).on('scroll', function (event) {
    var scroll = $(window).scrollTop();
    if (scroll < 10) {
      $(".navbar-area").removeClass("sticky");
    } else {
      $(".navbar-area").addClass("sticky");
    }
  });

  $("#form-error").hide();
  $("#form-success").hide();
  $('#submit_spinner').hide();

  $("#ebook-form-error").hide();
  $("#ebook-form-success").hide();

  $("#xmas-ebook-form-error").hide();
  $("#xmas-ebook-form-success").hide();

  $("#bf-ebook-form-error").hide();
  $("#bf-ebook-form-success").hide();

  //===== close navbar-collapse when a  clicked

  $(".navbar-nav a").on('click', function () {
    $(".navbar-collapse").removeClass("show");
  });

  //===== Mobile Menu

  $(".navbar-toggler").on('click', function () {
    $(this).toggleClass("active");
  });

  $(".navbar-nav a").on('click', function () {
    $(".navbar-toggler").removeClass('active');
  });


  //===== Section Menu Active

  var scrollLink = $('.page-scroll');
  // Active link switching
  $(window).scroll(function () {
    var scrollbarLocation = $(this).scrollTop();

    scrollLink.each(function () {

      var sectionOffset = $(this.hash).offset().top - 73;

      if (sectionOffset <= scrollbarLocation) {
        $(this).parent().addClass('active');
        $(this).parent().siblings().removeClass('active');
      }
    });
  });


  //===== Sidebar

  // $('[href="#side-menu-right"], .overlay-right').on('click', function (event) {
  //   $('.sidebar-right, .overlay-right').addClass('open');
  // });

  // $('[href="#close"], .overlay-right').on('click', function (event) {
  //   $('.sidebar-right, .overlay-right').removeClass('open');
  // });



  //===== Isotope Project 3

  // $('.container').imagesLoaded(function () {
  //   var $grid = $('.grid').isotope({
  //     // options
  //     transitionDuration: '1s'
  //   });

  //   // filter items on button click
  //   $('.portfolio-menu ul').on('click', 'li', function () {
  //     var filterValue = $(this).attr('data-filter');
  //     $grid.isotope({
  //       filter: filterValue
  //     });
  //   });

  //   //for menu active class
  //   $('.portfolio-menu ul li').on('click', function (event) {
  //     $(this).siblings('.active').removeClass('active');
  //     $(this).addClass('active');
  //     event.preventDefault();
  //   });
  // });


  //  Magnific Popup

  // $('.image-popup').magnificPopup({
  //   type: 'image',
  //   gallery: {
  //     enabled: true
  //   }
  // });

  //====== Magnific Popup

  // $('.video-popup').magnificPopup({
  //   type: 'iframe'
  //   // other options
  // });


  //===== Slick

  $('.testimonial-active').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 800,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });

  $('#testimonial2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });


  // ===== Slick

  $('.testimonial-active-2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });


  // ===== Slick

  $('.client-active').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 800,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          arrows: false,
        }
      }
    ]
  });


  // ===== Slick

  // $('.testimonial-active-4').slick({
  //   infinite: true,
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   speed: 800,
  //   arrows: false,
  //   dots: true,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 2,
  //       }
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 2,
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1,
  //       }
  //     },
  //     {
  //       breakpoint: 576,
  //       settings: {
  //         slidesToShow: 1,
  //         arrows: false,
  //       }
  //     }
  //   ]
  // });


  //===== Back to top

  // Show or hide the sticky footer button
  $(window).on('scroll', function (event) {
    if ($(this).scrollTop() > 600) {
      $('.back-to-top').fadeIn(200)
    } else {
      $('.back-to-top').fadeOut(200)
    }
  });


  //Animate the scroll to yop
  $('.back-to-top').on('click', function (event) {
    event.preventDefault();

    $('html, body').animate({
      scrollTop: 0,
    }, 1500);
  });


  //=====  AOS fin

  //=====
});


function submitToAPI(e, recaptcha, type) {
  e.preventDefault();
  var URL = "https://8psiz32q47.execute-api.eu-west-1.amazonaws.com/contact";
  var name = null;
  var email = null;
  var desc = null;
  var phone = null;
  if (type === 'bf') {
    name = $("#bf-ebook-name-input").val();
    email = $("#bf-ebook-email-input").val();
    desc = 'OFERTA BLACK FRIDAY';

    $('#bf-ebook_submit_spinner').show();
    $('#bf-ebook_submit_button').contents().last().replaceWith('Enviando...');
  } else {
    name = $("#name-input").val();
    email = $("#email-input").val();
    phone = $("#phone-input").val();
    desc = '**NNUEVO ALUMNO CHATGPT**' + $("#description-input").val();

    $('#submit_spinner').show();
    $('#submit_button').contents().last().replaceWith('Enviando...');
  }

  var data = {
    name: name,
    email: email,
    desc: desc,
    recaptcha,
  };

  if(phone !== null) {
    data.phone = phone;
  }

  $.ajax({
    type: "POST",
    url: URL,
    crossDomain: "true",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(data),
    timeout: 10000,

    success: function () {
      if (type === 'bf') {
        $("#bf-ebook-form-success").show();
        $('#bf-ebook-form').removeClass('was-validated');
        document.getElementById("bf-ebook-form").reset();
        grecaptcha.reset(bfEbookRecaptchaId);
        $('#bf-ebook_submit_spinner').hide();
        $('#bf-ebook_submit_button').contents().last().replaceWith('Enviar');
      } else {
        $("#form-success").show();
        $('#contact-form').removeClass('was-validated');
        document.getElementById("contact-form").reset();
        grecaptcha.reset(contactRecaptchaId);
        $('#submit_spinner').hide();
        $('#submit_button').contents().last().replaceWith('Enviar');

      }
    },
    error: function (xhr, textStatus, error) {
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
      if (type === 'bf') {
        $("#bf-ebook-form-error").show();
        $('#bf-ebook_submit_spinner').hide();
        $('#bf-ebook_submit_button').contents().last().replaceWith('Enviar');
        grecaptcha.reset(bfEbookRecaptchaId);
        $("#bf-ebook_submit_button").addClass('disabled');
      } else {
        $("#form-error").show();
        $('#submit_spinner').hide();
        $('label').contents().last().replaceWith('Enviar');
        grecaptcha.reset(contactRecaptchaId);
        $("#submit_button").addClass('disabled');
      }

    },
  });
}


function submitEbookToAPI(e, recaptcha, type) {
  e.preventDefault();
  var URL = "https://8psiz32q47.execute-api.eu-west-1.amazonaws.com/ebook";

  if (type === 'xmas') {
    // ebook xmas
    var name = $("#xmas-ebook-name-input").val();
    var email = $("#xmas-ebook-email-input").val();
    var company = $("#xmas-ebook-company-input").val();
    var data = {
      name: name,
      email: email,
      company: company,
      recaptcha,
      ebook: 'xmas',
    };

    $('#xmas-ebook_submit_button').contents().last().replaceWith('Enviando...');
  } else {
    // ebook normal
    var name = $("#ebook-name-input").val();
    var email = $("#ebook-email-input").val();
    var company = $("#ebook-company-input").val();
    var data = {
      name: name,
      email: email,
      company: company,
      recaptcha,
    };

    $('#ebook_submit_button').contents().last().replaceWith('Enviando...');
  }

  $.ajax({
    type: "POST",
    url: URL,
    crossDomain: "true",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(data),
    timeout: 10000,

    success: function () {
      // clear form and show a success 
      if (type === 'xmas') {
        // ebook xmas
        $("#xmas-ebook-form-success").show();
        $('#xmas-ebook-form').removeClass('was-validated');
        document.getElementById("xmas-ebook-form").reset();
        grecaptcha.reset(xmasEbookRecaptchaId);
        $('#xmas-ebook_submit_button').contents().last().replaceWith('Enviar');
      } else {
        $("#ebook-form-success").show();
        $('#ebook-form').removeClass('was-validated');
        document.getElementById("ebook-form").reset();
        grecaptcha.reset(ebookRecaptchaId);
        $('#ebook_submit_button').contents().last().replaceWith('Enviar');
      }
    },
    error: function (xhr, textStatus, error) {
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
      if (type === 'xmas') {
        $("#xmas-ebook-form-error").show();
        $('#xmas-ebook_submit_button').contents().last().replaceWith('Enviar');
        grecaptcha.reset(xmasEbookRecaptcha);
        $("#xmas-ebook_submit_button").addClass('disabled');
      } else {
        $("#ebook-form-error").show();
        $('#ebook_submit_button').contents().last().replaceWith('Enviar');
        grecaptcha.reset(ebookRecaptchaId);
        $("#ebook_submit_button").addClass('disabled');
      }
    },
  });
}